export const getSessionToken = () => {
  var sessionToken = document.cookie.match(/sessionToken=[^;]+/)
  if (sessionToken != null) {
    if (sessionToken instanceof Array) sessionToken = sessionToken[0].substring(13)
    else sessionToken = sessionToken.substring(13)
  }
  return sessionToken
}

export const getLinkedinSessionToken = () => {
  var sessionToken = document.cookie.match(/linkedinSessionToken=[^;]+/)
  if (sessionToken != null) {
    if (sessionToken instanceof Array) sessionToken = sessionToken[0].substring(21)
    else sessionToken = sessionToken.substring(21)
  }
  return sessionToken
}

export const alertError = (error) => {
  let errorMessage = 'An error occurred. Please try again.'
  
  if (error.response && error.response.data) {
    // Check for message property
    if (error.response.data.message) {
      errorMessage = error.response.data.message
    }
    // Check for error property (common alternative)
    else if (error.response.data.error) {
      errorMessage = error.response.data.error
    }
    // Check for status text
    else if (error.response.statusText) {
      errorMessage = `Error: ${error.response.status} ${error.response.statusText}`
    }
  }
  // Handle network errors or no response
  else if (error.message) {
    errorMessage = error.message
  }
  
  alert(errorMessage)
}

export const delay = (time) => {
    return new Promise(function (resolve) {
        setTimeout(resolve, time)
    });
}

export const buildReferralLink = (referralCode) => {
    return `https://trykitt.ai/signup?referralCode=${referralCode}`
}
